import { FileDataService } from './fileDataService';

// Deterministic-ish, collision-resistant base name for a post photo's S3 keys:
// {first 8 chars of child's unique id}_{dd}_{MMM}_{yyyy}_{HH}_{mm}_{uuid8}
export function makeBaseName(childUniqueId: string, dateISO: string): string {
  const dateObj = new Date(dateISO);
  const dd = String(dateObj.getDate()).padStart(2, '0');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const MMM = months[dateObj.getMonth()];
  const yyyy = dateObj.getFullYear();
  const HH = String(dateObj.getHours()).padStart(2, '0');
  const mm = String(dateObj.getMinutes()).padStart(2, '0');
  const formattedDate = `${dd}_${MMM}_${yyyy}_${HH}_${mm}`;
  const uuid = typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID().substring(0, 8)
    : Math.random().toString(36).substring(2, 10);
  return `${childUniqueId.substring(0, 8)}_${formattedDate}_${uuid}`;
}

// Resize + presign + upload; returns the stored (unprefixed) S3 key.
export async function putImage(
  source: File,
  fileName: string,
  maxDim: number,
  quality: number,
  childUniqueId: string,
): Promise<string> {
  const blob = await FileDataService.resizeImage(source, maxDim, quality);
  const presigned = await FileDataService.getPresignedUrl(fileName, 'image/jpeg', childUniqueId);
  await FileDataService.uploadToS3(presigned.signedUrl, blob);
  return presigned.fileKey;
}

// Upload a redacted file as a main + thumbnail "modified" variant.
export async function putModifiedVariant(
  redacted: File,
  baseName: string,
  childUniqueId: string,
): Promise<{ modified_s3_key: string; modified_s3_key_thumbnail: string }> {
  return {
    modified_s3_key: await putImage(redacted, `${baseName}_redacted.jpg`, 800, 0.75, childUniqueId),
    modified_s3_key_thumbnail: await putImage(redacted, `${baseName}_redacted_thumb.jpg`, 200, 0.5, childUniqueId),
  };
}
